export enum TargetEnum {
  DynamicPackages = 'DP',
  HotelOnly = 'HO',
  Flights = 'FF',
  TrainHotel = 'TH',
}
